import React from 'react';
const DeviceContext = React.createContext({
    platform: null,
    gpb_supported: false,
});
export default DeviceContext;
//# sourceMappingURL=device.js.map